import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-message-token',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: false
})
export class MessageComponent implements OnInit {

  message: string;
  content: any;
  messageTypes = ['default', 'setToken', 'invalidToken', 'logout', 'autologout'];
  contents = [
    { title: 'Message', message: '' },
    { title: null, message: 'Bitte überprüfen Sie Ihre E-Mails, um Ihr Passwort zurückzusetzen.' },
    { title: 'Error', message: 'Your token is not valid. Please try to get a new one' },
    { title: 'Successfully logged out', message: '' },
    { title: null, message: 'Sie wurden automatisch ausgeloggt.' }
  ];

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    const messageType = this.route.snapshot.queryParams['messagetype'] || 'default';
    this.content = this.contents[this.messageTypes.indexOf(messageType)];
  }

  navigateToLogin() {
    this.router.navigate([{ outlets: { 'authentication': ['login'] } }], { relativeTo: this.route.parent });
  }
}
